/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateInsuredPersonCommandDto,
  CreateSimulationCommandDto,
  CreateSimulationResponseDto,
  ErrorResponse,
  EvaluateEligibilityCommandDto,
  EvaluateEligibilityResponseDto,
  GetAdminRiskListResponseDto,
  GetBeneficiariesResponse,
  GetBrokerBranches404Response,
  GetBrokerBranchesResponseDto,
  GetFacetsResponse,
  GetFileGroupResponse,
  GetGenericListCommandDto,
  GetRgiRiskResponse,
  GetRiskListResponseDto,
  GetRiskSimulationsResponseDto,
  GetSimulationFilterResponseDto,
  GetUnemploymentRiskResponse,
  GetUpiRiskResponse,
  LegalProtectionEligibilityResponse,
  LinkParcToRisqueCommandDto,
  LinkRealEstateCommandDto,
  OperationResponse,
  PatchRgiRiskCommandDto,
  SaveAnswerCommandDto,
  SubscriptionProcessResponse,
  UnemploymentSurveyResponse,
} from '../models/index';
import {
    CreateInsuredPersonCommandDtoFromJSON,
    CreateInsuredPersonCommandDtoToJSON,
    CreateSimulationCommandDtoFromJSON,
    CreateSimulationCommandDtoToJSON,
    CreateSimulationResponseDtoFromJSON,
    CreateSimulationResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EvaluateEligibilityCommandDtoFromJSON,
    EvaluateEligibilityCommandDtoToJSON,
    EvaluateEligibilityResponseDtoFromJSON,
    EvaluateEligibilityResponseDtoToJSON,
    GetAdminRiskListResponseDtoFromJSON,
    GetAdminRiskListResponseDtoToJSON,
    GetBeneficiariesResponseFromJSON,
    GetBeneficiariesResponseToJSON,
    GetBrokerBranches404ResponseFromJSON,
    GetBrokerBranches404ResponseToJSON,
    GetBrokerBranchesResponseDtoFromJSON,
    GetBrokerBranchesResponseDtoToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetFileGroupResponseFromJSON,
    GetFileGroupResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetRgiRiskResponseFromJSON,
    GetRgiRiskResponseToJSON,
    GetRiskListResponseDtoFromJSON,
    GetRiskListResponseDtoToJSON,
    GetRiskSimulationsResponseDtoFromJSON,
    GetRiskSimulationsResponseDtoToJSON,
    GetSimulationFilterResponseDtoFromJSON,
    GetSimulationFilterResponseDtoToJSON,
    GetUnemploymentRiskResponseFromJSON,
    GetUnemploymentRiskResponseToJSON,
    GetUpiRiskResponseFromJSON,
    GetUpiRiskResponseToJSON,
    LegalProtectionEligibilityResponseFromJSON,
    LegalProtectionEligibilityResponseToJSON,
    LinkParcToRisqueCommandDtoFromJSON,
    LinkParcToRisqueCommandDtoToJSON,
    LinkRealEstateCommandDtoFromJSON,
    LinkRealEstateCommandDtoToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    PatchRgiRiskCommandDtoFromJSON,
    PatchRgiRiskCommandDtoToJSON,
    SaveAnswerCommandDtoFromJSON,
    SaveAnswerCommandDtoToJSON,
    SubscriptionProcessResponseFromJSON,
    SubscriptionProcessResponseToJSON,
    UnemploymentSurveyResponseFromJSON,
    UnemploymentSurveyResponseToJSON,
} from '../models/index';

export interface CreateInsuredPersonByBranchCodeRequest {
    createInsuredPersonCommandDto: CreateInsuredPersonCommandDto;
}

export interface EvaluateEligibilityRequest {
    evaluateEligibilityCommandDto: EvaluateEligibilityCommandDto;
}

export interface FetchRgiRiskRequest {
    riskId: string;
}

export interface FetchUnemploymentRiskRequest {
    riskId: string;
}

export interface FetchUpiRiskRequest {
    riskId: string;
}

export interface GetAdminSimulationListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAdminSimulationsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAllSimulationInProgressRequest {
    branchCode: string;
}

export interface GetBeneficiairesRequest {
    risqueAssureId: string;
}

export interface GetDossiersGroupeRequest {
    risqueAssureId: string;
}

export interface GetLegalProtectionEligibilityRequest {
    risqueAssureId: string;
}

export interface GetSimulationListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetSimulationsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetSubscriptionProcessRequest {
    riskId: string;
    devisId?: string;
}

export interface GetSubscriptionProcessBorrowerRequest {
    projetEmpruntId: string;
    emprunteurId?: string;
    devisId?: string;
}

export interface InitSimulationByBranchCodeRequest {
    createSimulationCommandDto: CreateSimulationCommandDto;
}

export interface LinkParcToRisqueRequest {
    linkParcToRisqueCommandDto: LinkParcToRisqueCommandDto;
}

export interface LinkRealEstateRequest {
    linkRealEstateCommandDto: LinkRealEstateCommandDto;
}

export interface PatchSurveyRequest {
    riskId: string;
    saveAnswerCommandDto: SaveAnswerCommandDto;
}

export interface PathRGIRiskRequest {
    riskId: string;
    patchRgiRiskCommandDto: PatchRgiRiskCommandDto;
}

/**
 * 
 */
export class RisksApi extends runtime.BaseAPI {

    /**
     * Create Insured Person and Associated Risk
     */
    async createInsuredPersonByBranchCodeRaw(requestParameters: CreateInsuredPersonByBranchCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createInsuredPersonCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createInsuredPersonCommandDto',
                'Required parameter "createInsuredPersonCommandDto" was null or undefined when calling createInsuredPersonByBranchCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques-assures-personnes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInsuredPersonCommandDtoToJSON(requestParameters['createInsuredPersonCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create Insured Person and Associated Risk
     */
    async createInsuredPersonByBranchCode(requestParameters: CreateInsuredPersonByBranchCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createInsuredPersonByBranchCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Evaluate real estate eligibility for a branch (GLI / CBNO)
     */
    async evaluateEligibilityRaw(requestParameters: EvaluateEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EvaluateEligibilityResponseDto>> {
        if (requestParameters['evaluateEligibilityCommandDto'] == null) {
            throw new runtime.RequiredError(
                'evaluateEligibilityCommandDto',
                'Required parameter "evaluateEligibilityCommandDto" was null or undefined when calling evaluateEligibility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/eligibilite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EvaluateEligibilityCommandDtoToJSON(requestParameters['evaluateEligibilityCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EvaluateEligibilityResponseDtoFromJSON(jsonValue));
    }

    /**
     * Evaluate real estate eligibility for a branch (GLI / CBNO)
     */
    async evaluateEligibility(requestParameters: EvaluateEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EvaluateEligibilityResponseDto> {
        const response = await this.evaluateEligibilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get RGI risk by Id
     */
    async fetchRgiRiskRaw(requestParameters: FetchRgiRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRgiRiskResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling fetchRgiRisk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/risques/{riskId}/gli`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRgiRiskResponseFromJSON(jsonValue));
    }

    /**
     * Get RGI risk by Id
     */
    async fetchRgiRisk(requestParameters: FetchRgiRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRgiRiskResponse> {
        const response = await this.fetchRgiRiskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Unemployment risk by Id
     */
    async fetchUnemploymentRiskRaw(requestParameters: FetchUnemploymentRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUnemploymentRiskResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling fetchUnemploymentRisk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/risques/{riskId}/chomage`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUnemploymentRiskResponseFromJSON(jsonValue));
    }

    /**
     * Get Unemployment risk by Id
     */
    async fetchUnemploymentRisk(requestParameters: FetchUnemploymentRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUnemploymentRiskResponse> {
        const response = await this.fetchUnemploymentRiskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get UPI risk by Id
     */
    async fetchUpiRiskRaw(requestParameters: FetchUpiRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUpiRiskResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling fetchUpiRisk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/risques/{riskId}/cbno`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUpiRiskResponseFromJSON(jsonValue));
    }

    /**
     * Get UPI risk by Id
     */
    async fetchUpiRisk(requestParameters: FetchUpiRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUpiRiskResponse> {
        const response = await this.fetchUpiRiskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facettes de la liste admin des simulations, avec la dimension courtiers (pas de plateformes : une simulation n\'est pas rattachée à une orga). Permission BackOffice.AdminSimulations.Read (403 sinon). 
     * Get admin simulation list facets (BO admin)
     */
    async getAdminSimulationListFacetsRaw(requestParameters: GetAdminSimulationListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminSimulationListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/admin/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes de la liste admin des simulations, avec la dimension courtiers (pas de plateformes : une simulation n\'est pas rattachée à une orga). Permission BackOffice.AdminSimulations.Read (403 sinon). 
     * Get admin simulation list facets (BO admin)
     */
    async getAdminSimulationListFacets(requestParameters: GetAdminSimulationListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getAdminSimulationListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste admin paginée des simulations, toutes plateformes. Items enrichis de brokerId/brokerName (pas de plateforme : une simulation n\'y est pas rattachée). filters.brokerIds est disponible. Permission BackOffice.AdminSimulations.Read (403 sinon). Remplace l\'usage admin de /api/backoffice/risques/liste. 
     * Get simulations, all plateformes (BO admin)
     */
    async getAdminSimulationsRaw(requestParameters: GetAdminSimulationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAdminRiskListResponseDto>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminSimulations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/admin/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAdminRiskListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Liste admin paginée des simulations, toutes plateformes. Items enrichis de brokerId/brokerName (pas de plateforme : une simulation n\'y est pas rattachée). filters.brokerIds est disponible. Permission BackOffice.AdminSimulations.Read (403 sinon). Remplace l\'usage admin de /api/backoffice/risques/liste. 
     * Get simulations, all plateformes (BO admin)
     */
    async getAdminSimulations(requestParameters: GetAdminSimulationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAdminRiskListResponseDto> {
        const response = await this.getAdminSimulationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get All in progress simulations
     */
    async getAllSimulationInProgressRaw(requestParameters: GetAllSimulationInProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRiskSimulationsResponseDto>> {
        if (requestParameters['branchCode'] == null) {
            throw new runtime.RequiredError(
                'branchCode',
                'Required parameter "branchCode" was null or undefined when calling getAllSimulationInProgress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/risques/simulations/{branchCode}`.replace(`{${"branchCode"}}`, encodeURIComponent(String(requestParameters['branchCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRiskSimulationsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get All in progress simulations
     */
    async getAllSimulationInProgress(requestParameters: GetAllSimulationInProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRiskSimulationsResponseDto> {
        const response = await this.getAllSimulationInProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the beneficiaries of a risk
     */
    async getBeneficiairesRaw(requestParameters: GetBeneficiairesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBeneficiariesResponse>> {
        if (requestParameters['risqueAssureId'] == null) {
            throw new runtime.RequiredError(
                'risqueAssureId',
                'Required parameter "risqueAssureId" was null or undefined when calling getBeneficiaires().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/risques/{risqueAssureId}/beneficiaires`.replace(`{${"risqueAssureId"}}`, encodeURIComponent(String(requestParameters['risqueAssureId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBeneficiariesResponseFromJSON(jsonValue));
    }

    /**
     * Get the beneficiaries of a risk
     */
    async getBeneficiaires(requestParameters: GetBeneficiairesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBeneficiariesResponse> {
        const response = await this.getBeneficiairesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get broker branches
     */
    async getBrokerBranchesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBrokerBranchesResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/risques/branches-courtier`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBrokerBranchesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get broker branches
     */
    async getBrokerBranches(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBrokerBranchesResponseDto> {
        const response = await this.getBrokerBranchesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the files created together with a risk, for the file selector
     */
    async getDossiersGroupeRaw(requestParameters: GetDossiersGroupeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFileGroupResponse>> {
        if (requestParameters['risqueAssureId'] == null) {
            throw new runtime.RequiredError(
                'risqueAssureId',
                'Required parameter "risqueAssureId" was null or undefined when calling getDossiersGroupe().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/risques/{risqueAssureId}/dossiers-groupe`.replace(`{${"risqueAssureId"}}`, encodeURIComponent(String(requestParameters['risqueAssureId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFileGroupResponseFromJSON(jsonValue));
    }

    /**
     * Get the files created together with a risk, for the file selector
     */
    async getDossiersGroupe(requestParameters: GetDossiersGroupeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFileGroupResponse> {
        const response = await this.getDossiersGroupeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the legal protection eligibility of a risk (cumulative revenue of the company and its subsidiaries)
     */
    async getLegalProtectionEligibilityRaw(requestParameters: GetLegalProtectionEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegalProtectionEligibilityResponse>> {
        if (requestParameters['risqueAssureId'] == null) {
            throw new runtime.RequiredError(
                'risqueAssureId',
                'Required parameter "risqueAssureId" was null or undefined when calling getLegalProtectionEligibility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/risques/{risqueAssureId}/protection-juridique/eligibilite`.replace(`{${"risqueAssureId"}}`, encodeURIComponent(String(requestParameters['risqueAssureId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegalProtectionEligibilityResponseFromJSON(jsonValue));
    }

    /**
     * Get the legal protection eligibility of a risk (cumulative revenue of the company and its subsidiaries)
     */
    async getLegalProtectionEligibility(requestParameters: GetLegalProtectionEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegalProtectionEligibilityResponse> {
        const response = await this.getLegalProtectionEligibilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get simulation filters
     */
    async getSimulationFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSimulationFilterResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/risques/filtres`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSimulationFilterResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get simulation filters
     */
    async getSimulationFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSimulationFilterResponseDto> {
        const response = await this.getSimulationFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Facettes du panneau de filtres de la liste des simulations (espace courtier). Envoyer les filtres courants dans le body : les options d\'une dimension sont calculées avec tous les filtres sauf celui de la dimension elle-même. À rappeler à l\'ouverture du panneau et à chaque changement de filtre ou de searchString (debounce ~300 ms) — pas au changement de page. 
     * Get simulation list facets (courtier)
     */
    async getSimulationListFacetsRaw(requestParameters: GetSimulationListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getSimulationListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes du panneau de filtres de la liste des simulations (espace courtier). Envoyer les filtres courants dans le body : les options d\'une dimension sont calculées avec tous les filtres sauf celui de la dimension elle-même. À rappeler à l\'ouverture du panneau et à chaque changement de filtre ou de searchString (debounce ~300 ms) — pas au changement de page. 
     * Get simulation list facets (courtier)
     */
    async getSimulationListFacets(requestParameters: GetSimulationListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getSimulationListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get simulations
     */
    async getSimulationsRaw(requestParameters: GetSimulationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRiskListResponseDto>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getSimulations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRiskListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get simulations
     */
    async getSimulations(requestParameters: GetSimulationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRiskListResponseDto> {
        const response = await this.getSimulationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the complete subscription process state including: - Current step and all steps with their status - Risk data (when not in contractualization) OR contractualization data (when in contractualization)  The backend determines which data to return based on the current step.  When in contractualization step, the contractualizationData will contain the ContractualizationResponseDto. If a specific devisId is provided, the contractualization data for that specific quote will be loaded. 
     * Get subscription process state and data by risk ID
     */
    async getSubscriptionProcessRaw(requestParameters: GetSubscriptionProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionProcessResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling getSubscriptionProcess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['devisId'] != null) {
            queryParameters['devisId'] = requestParameters['devisId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/process-souscriptions/{riskId}/steps`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionProcessResponseFromJSON(jsonValue));
    }

    /**
     * Returns the complete subscription process state including: - Current step and all steps with their status - Risk data (when not in contractualization) OR contractualization data (when in contractualization)  The backend determines which data to return based on the current step.  When in contractualization step, the contractualizationData will contain the ContractualizationResponseDto. If a specific devisId is provided, the contractualization data for that specific quote will be loaded. 
     * Get subscription process state and data by risk ID
     */
    async getSubscriptionProcess(requestParameters: GetSubscriptionProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionProcessResponse> {
        const response = await this.getSubscriptionProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the complete subscription process state for a borrower project. A borrower project contains N borrowers (insured risks).  Returns: - Current step and all steps with their status - Risk data (when not in contractualization) OR contractualization data (when in contractualization)  The backend determines which data to return based on the current step.  When in contractualization step, the contractualizationData will contain the ContractualizationResponseDto. If a specific devisId is provided, the contractualization data for that specific quote will be loaded. 
     * Get subscription process state for a borrower project
     */
    async getSubscriptionProcessBorrowerRaw(requestParameters: GetSubscriptionProcessBorrowerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionProcessResponse>> {
        if (requestParameters['projetEmpruntId'] == null) {
            throw new runtime.RequiredError(
                'projetEmpruntId',
                'Required parameter "projetEmpruntId" was null or undefined when calling getSubscriptionProcessBorrower().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['emprunteurId'] != null) {
            queryParameters['emprunteurId'] = requestParameters['emprunteurId'];
        }

        if (requestParameters['devisId'] != null) {
            queryParameters['devisId'] = requestParameters['devisId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/process-souscriptions/emprunteurs/projet-emprunts/{projetEmpruntId}/steps`.replace(`{${"projetEmpruntId"}}`, encodeURIComponent(String(requestParameters['projetEmpruntId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionProcessResponseFromJSON(jsonValue));
    }

    /**
     * Returns the complete subscription process state for a borrower project. A borrower project contains N borrowers (insured risks).  Returns: - Current step and all steps with their status - Risk data (when not in contractualization) OR contractualization data (when in contractualization)  The backend determines which data to return based on the current step.  When in contractualization step, the contractualizationData will contain the ContractualizationResponseDto. If a specific devisId is provided, the contractualization data for that specific quote will be loaded. 
     * Get subscription process state for a borrower project
     */
    async getSubscriptionProcessBorrower(requestParameters: GetSubscriptionProcessBorrowerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionProcessResponse> {
        const response = await this.getSubscriptionProcessBorrowerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initialize Simulation process by branch code
     */
    async initSimulationByBranchCodeRaw(requestParameters: InitSimulationByBranchCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSimulationResponseDto>> {
        if (requestParameters['createSimulationCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createSimulationCommandDto',
                'Required parameter "createSimulationCommandDto" was null or undefined when calling initSimulationByBranchCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/simulation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSimulationCommandDtoToJSON(requestParameters['createSimulationCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSimulationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Initialize Simulation process by branch code
     */
    async initSimulationByBranchCode(requestParameters: InitSimulationByBranchCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSimulationResponseDto> {
        const response = await this.initSimulationByBranchCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link a parc immobilier to the simulation risk
     */
    async linkParcToRisqueRaw(requestParameters: LinkParcToRisqueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['linkParcToRisqueCommandDto'] == null) {
            throw new runtime.RequiredError(
                'linkParcToRisqueCommandDto',
                'Required parameter "linkParcToRisqueCommandDto" was null or undefined when calling linkParcToRisque().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/parc-immobilier`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LinkParcToRisqueCommandDtoToJSON(requestParameters['linkParcToRisqueCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Link a parc immobilier to the simulation risk
     */
    async linkParcToRisque(requestParameters: LinkParcToRisqueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.linkParcToRisqueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link real estate to risk
     */
    async linkRealEstateRaw(requestParameters: LinkRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['linkRealEstateCommandDto'] == null) {
            throw new runtime.RequiredError(
                'linkRealEstateCommandDto',
                'Required parameter "linkRealEstateCommandDto" was null or undefined when calling linkRealEstate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/bien-immobilier`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LinkRealEstateCommandDtoToJSON(requestParameters['linkRealEstateCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Link real estate to risk
     */
    async linkRealEstate(requestParameters: LinkRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.linkRealEstateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch Unemployment survey by Id
     */
    async patchSurveyRaw(requestParameters: PatchSurveyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnemploymentSurveyResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling patchSurvey().'
            );
        }

        if (requestParameters['saveAnswerCommandDto'] == null) {
            throw new runtime.RequiredError(
                'saveAnswerCommandDto',
                'Required parameter "saveAnswerCommandDto" was null or undefined when calling patchSurvey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/{riskId}/chomage/reponses`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveAnswerCommandDtoToJSON(requestParameters['saveAnswerCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnemploymentSurveyResponseFromJSON(jsonValue));
    }

    /**
     * Patch Unemployment survey by Id
     */
    async patchSurvey(requestParameters: PatchSurveyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnemploymentSurveyResponse> {
        const response = await this.patchSurveyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch RGI risk
     */
    async pathRGIRiskRaw(requestParameters: PathRGIRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling pathRGIRisk().'
            );
        }

        if (requestParameters['patchRgiRiskCommandDto'] == null) {
            throw new runtime.RequiredError(
                'patchRgiRiskCommandDto',
                'Required parameter "patchRgiRiskCommandDto" was null or undefined when calling pathRGIRisk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/{riskId}/gli`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchRgiRiskCommandDtoToJSON(requestParameters['patchRgiRiskCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Patch RGI risk
     */
    async pathRGIRisk(requestParameters: PathRGIRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.pathRGIRiskRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
